import script from "./welfareTreasureGamePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./welfareTreasureGamePopup.vue?vue&type=script&setup=true&lang=js"

import "./welfareTreasureGamePopup.vue?vue&type=style&index=0&id=6c494232&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c494232"]])

export default __exports__